import * as angular from 'angular';
import * as _ from 'lodash';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import TopDefectsHubName, {TopDefectsHub, TopDefectsHubCreator} from "../../services/reports/topDefects.hub";

let requires = [LoaderServiceName, ReportServiceName, TopDefectsHubName];

class TopDefectsCtrl {
  shop: apsViewModels.ShopNavigation;
  plantTimeZoneId: string;
  queryStart: Date;
  queryEnd: Date;
  maxDefects: number;

  loaderService: LoaderService;
  reportService: ReportService;

  defects: apsViewModels.TopNDefectReportItem[];
  critical: boolean;
  private hub: TopDefectsHub;
  private $scope: angular.IScope;
  private $timeout: angular.ITimeoutService;

  constructor(loaderService: LoaderService,
              topDefectsHubCreator: TopDefectsHubCreator,
              $scope: angular.IScope,
              $timeout: angular.ITimeoutService,
              reportService: ReportService) {
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.critical = false;
    this.$scope = $scope;
    this.$timeout = $timeout;

    $timeout(() => {
      this.loadData();
      this.hub = topDefectsHubCreator.createTopDefectsHub(this.shop.id,
        d => this.onDefectAdded(d),
        d => this.onDefectRemoved(d)
      );
    });

    this.$scope.$on('$destroy', () => {
      if (this.hub) {
        this.hub.uninitialize();
      }
    });
  }

  private onDefectAdded(defect: apsViewModels.TopDefectEvent) {
    if (!this.defects || this.queryStart.getTime() > defect.timeFound.getTime()) {
      return;
    }

    this.$timeout(() => {
      var existing = _.find(this.defects, {defectTypeId: defect.defectTypeId});
      if (existing) {
        existing.count = existing.count + 1;
        if (existing.severity > defect.severity) {
          existing.severity = defect.severity;
        }
      } else {
        this.defects.push(<apsViewModels.TopNDefectReportItem>_.assign({count: 1}, defect));
      }
    });
  }

  private onDefectRemoved(defect: apsViewModels.TopDefectEvent) {
    if (!this.defects || this.queryStart.getTime() > defect.timeFound.getTime()) {
      return;
    }

    var existing = _.find(this.defects, {defectTypeId: defect.defectTypeId});
    if (!existing) {
      return;
    }

    this.$timeout(() => {
      existing.count = existing.count - 1;
      if (existing.count <= 0) {
        _.remove(this.defects, existing);
      }
    });
  }

  loadData(): void {
    var loadPromise = this.reportService.getTopDefectsReport(this.shop.id,
      this.queryStart,
      this.queryEnd,
      this.maxDefects,
      this.critical).then((defects) => {
        this.defects = defects;
      });
    this.loaderService.loadingPromise(loadPromise);
  }
}

export default angular.module('aps.controller.topDefects', requires)
  .controller('TopDefectsCtrl', TopDefectsCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/topDefects.controller.ts